import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const onDutyApi = {
  today: () => axios
    .get(`${API}/api/management/on-duty-today`, { withCredentials: true })
    .then((r) => r.data),
};
